export default function notUndefined(value) {
    return value !== undefined;
}
